/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRequestFileSearchResult } from './APIRequestFileSearchResult';
import {
    APIRequestFileSearchResultFromJSON,
    APIRequestFileSearchResultFromJSONTyped,
    APIRequestFileSearchResultToJSON,
} from './APIRequestFileSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIRequestFileSearchResponse
 */
export interface APIRequestFileSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIRequestFileSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIRequestFileSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIRequestFileSearchResult>}
     * @memberof APIRequestFileSearchResponse
     */
    results: Array<APIRequestFileSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIRequestFileSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIRequestFileSearchResponse interface.
 */
export function instanceOfAPIRequestFileSearchResponse(value: object): value is APIRequestFileSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIRequestFileSearchResponseFromJSON(json: any): APIRequestFileSearchResponse {
    return APIRequestFileSearchResponseFromJSONTyped(json, false);
}

export function APIRequestFileSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequestFileSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIRequestFileSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIRequestFileSearchResponseToJSON(value?: APIRequestFileSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIRequestFileSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

